// Combobox display text — name + id so the user can verify exactly which
// dataset is selected (names aren't unique in the Data Lake; ids are).
// Version lives in its own field so we don't repeat it here.
export function renderOptionText(d: {
  id: string;
  name: string;
  version: number;
}): string {
  return `${d.name} · ${d.id}`;
}
